import * as MediaAssetAPI from '@/api/media-asset';
import { useCurrentApp } from '@/stores/userDataStore';
import { useMediaAssetGeneration } from '@/hooks/useMediaAssetGeneration';
import { MediaAssetVideoProvider } from '@/types/media';
import {
  VideoMediaAssetDuration,
  VideoMediaAssetMode,
} from '@/features/ai-video-asset-creator/components/AIVideoAssetCreator';
interface GenerateVideoProps {
  productId?: string;
  productTitle?: string;
  imageSrc?: string;
  videoPrompt?: string;
  provider?: MediaAssetVideoProvider;
  duration?: VideoMediaAssetDuration;
  mode?: VideoMediaAssetMode;
}

export const useImageToVideo = () => {
  const { appKey, appUrl } = useCurrentApp();
  const result = useMediaAssetGeneration({
    mutationFn: async ({
      imageSrc,
      productId,
      productTitle,
      videoPrompt,
      provider,
      duration,
      mode,
    }: GenerateVideoProps) => {
      if (!imageSrc) return null;
      return await MediaAssetAPI.generateVideo({
        appKey,
        appUrl,
        image: imageSrc,
        videoPrompt: videoPrompt || undefined,
        productId,
        productTitle,
        autogenerated: false,
        provider,
        duration,
        mode,
      });
    },
  });

  return result;
};
